module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', [_vm._v("When Teresa was a small child, she lived in an orphanage called The Ark. It was there that she learned to respect and love the animal kingdom and all its beauty. Teresa found nature in the gardens, made friends with the birds and saw smiling faces in the flowers. This gave her the curiosity to find her imaginary fairies. Later, Teresa went to live in Pennsylvania, USA and was inspired by its incredible beauty and wildlife which was similar to her native England. During this time, a letter arrived from a dear friend, addressed to Lady Bluebell.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("As she opened the letter, pressed bluebells from her garden in England fell into her lap, igniting her imagination and helping her recall her childhood memories, bringing about the story of "), _c('em', [_vm._v("Lady Bluebell and Her Magical Gardens.")]), _vm._v(" As an adult and back in the UK, Teresa enhanced her watercolour skills, embracing her inner child. The paintings within these pages will speak to the hearts of everyone, young and old alike.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0px"
    }
  }, [_vm._v("“Lady Bluebell believes that if you think kind thoughts, nice things will happen. She wishes to share her gardens and wonderful experiences with you,” says Teresa.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0